module.exports = __webpack_public_path__ + "assets/img/cpys3.87bdecef.jpg";